








































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import productCoverDialog from "@/components/productCoverDialog.vue"; // @ is an alias to /src
import Goods from "@/components/goods.vue";
import Coupons from "@/components/coupons.vue";
@Component({
  components: {
    productCoverDialog,
    Goods,
    Coupons,
  },
})
export default class Step extends Vue {
  constructor(props: any) {
    super(props);
  }

  public created() {
    const { id } = this.$router.currentRoute.params;
    this.$data.member_join_url = this.$store.state.userInfo.member_join_url;
    this.$data.MemberLinkDisable = this.$store.state.userInfo.member_join_url
      ? true
      : false;
    if (id) {
      this.queryActInfo(id);
    }
  }

  public async queryActInfo(id: any) {
    const loading = (this as any).$loading({
      lock: true,
      text: "加载中",
      spinner: "el-icon-loading",
    });
    try {
      const result = await this.$store.dispatch("actDetail", { id });
      result.dateRange = [result.begin_at, result.end_at];
      result.settings.status = result.settings.status ? true : false;
      result.activity_instance_id = id;
      this.$data.ruleForm = Object.assign({}, this.$data.ruleForm, result);
      // await this.validate();
      loading.close();
    } catch (error) {
      loading.close();
      (this as any).$message.error(error.msg || error.message || error);
    }
  }

  public data() {
    const checkDate = (rule: any, value: any = [], callback: any) => {
      const beginAt = value && +new Date(value[0]);
      const endAt = value && +new Date(value[1]);
      const now = +Date.now();
      const id = this.$router.currentRoute.params.id;
      const canbeDelete = this.$data.canbeDelete;
      const { status } = this.$data.ruleForm;
      if (!value) {
        return callback(new Error("请选择日期"));
      } else if ((!id || canbeDelete.includes(status)) && beginAt < now) {
        // [ "创建中", "未发布", "暂停", "未开始", "结束", "进行中" ],
        // 没有ID 或 活动状态 0，1，3  && 开始时间小于当前时间
        return callback(new Error("开始时间小于当前时间"));
      } else if (beginAt >= endAt) {
        return callback(new Error("开始时间需小于结束时间"));
      } else {
        return callback();
      }
    };

    return {
      // 商品优惠券相关
      goodsInfo: {
        goods: [],
        goodsShow: false,
      },
      goodsIndex: 0,
      couponsInfo: {
        couponsId: null,
        couponsShow: false,
      },
      couponsIndex: 0,
      MemberLinkDisable: "",
      linkLoading: false,
      member_join_url: "",
      ruleForm: {
        activity_instance_id: "",
        activity_id: 14, // 固定值，代表jd组合购
        name: "",
        dateRange: "",
        begin_at: "",
        end_at: "",
        is_need_member: "",
        styles: {
          group: "4",
          view_mode: "1",
          background_image: null,
        },
        options: {
          template_id: 1, // 模板，0完整版 1 工具版 创建必传
          query: "template_id=1",
        },
        settings: {
          // 满减满赠
          status: false,
          rules: [
            {
              amount: undefined,
              ways: "1",
              content: "",
              coupon_name: "",
              coupon_id: "",
            },
          ],
        },
        goods_group_list: [
          {
            name: "组合礼包1",
            cover:
              "http://enbrands-2.oss-cn-shanghai.aliyuncs.com/user/8099425d04e81defed860bf7f4b35348.png",
            is_recommend: 0,
            relative_goods: [],
            ids: [],
            goods_list: []
          },
          {
            name: "组合礼包2",
            cover:
              "http://enbrands-2.oss-cn-shanghai.aliyuncs.com/user/8099425d04e81defed860bf7f4b35348.png",
            is_recommend: 0,
            relative_goods: [],
            ids: [],
            goods_list: []
          },
          {
            name: "组合礼包3",
            cover:
              "http://enbrands-2.oss-cn-shanghai.aliyuncs.com/user/8099425d04e81defed860bf7f4b35348.png",
            is_recommend: 0,
            relative_goods: [],
            ids: [],
            goods_list: []
          },
          {
            name: "组合礼包4",
            cover:
              "http://enbrands-2.oss-cn-shanghai.aliyuncs.com/user/8099425d04e81defed860bf7f4b35348.png",
            is_recommend: 0,
            relative_goods: [],
            ids: [],
            goods_list: []
          },
        ],
      },
      imageTipDefault:
        "//enbrands-2.oss-cn-shanghai.aliyuncs.com/user/2dc80eef3a00af187a87e3729433f00d.png",
      canbeDelete: [0, 1, 3],
      options: [
        {
          value: "1",
          label: "1",
        },
        {
          value: "2",
          label: "2",
        },
        {
          value: "3",
          label: "3",
        },
        {
          value: "4",
          label: "4",
        },
        {
          value: "5",
          label: "5",
        },
        {
          value: "6",
          label: "6",
        },
        {
          value: "7",
          label: "7",
        },
        {
          value: "8",
          label: "8",
        },
      ],
      productCoverDialogData: {
        show: false,
        currentIndex: "",
        cover: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入活动名称",
            trigger: "blur",
          },
          {
            min: 3,
            max: 20,
            message: "长度在 3 到 20 个字符",
            trigger: "blur",
          },
        ],
        dateRange: [
          { validator: checkDate, trigger: "change", required: true },
        ],
        is_need_member: [
          {
            required: true,
            message: "请选择参与门槛",
            trigger: "change",
          },
        ],
      },
      isbgChoose: false,
    };
  }

  public checkName(rule: any, value: any = [], callback: any) {
    const sameNames = this.$data.ruleForm.goods_group_list.filter(
      (k: any) => k.name == value
    );

    if (!value) {
      return callback(new Error("请输入商品组合名称"));
    } else if (value.length > 12) {
      return callback(new Error("长度在1到20个字符"));
    } else if (sameNames.length > 1) {
      return callback(new Error("组合名称重复"));
    } else {
      return callback();
    }
  }

  public async submitLink() {
    if (!this.$data.member_join_url) {
      (this as any).$message.error("请配置入会地址");
      return;
    }
    this.$data.linkLoading = true;
    try {
      await this.$store.dispatch("setMemberLink", {
        bind_url: this.$data.member_join_url,
      });
      this.$data.linkLoading = false;
      this.$data.member_join_url = this.$store.state.userInfo.member_join_url;
      this.$data.MemberLinkDisable = this.$store.state.userInfo.member_join_url
        ? true
        : false;
    } catch (error) {
      this.$data.linkLoading = false;
      (this as any).$message.error(error.msg || error.message || error);
    }
  }

  public cancelLink() {
    this.$data.member_join_url = this.$store.state.userInfo.member_join_url;
    this.$data.MemberLinkDisable = this.$store.state.userInfo.member_join_url
      ? true
      : false;
  }

  public onDateChange(value: any) {
    const id = this.$router.currentRoute.params.id;
    const canbeDelete = this.$data.canbeDelete;
    const { status } = this.$data.ruleForm;
    if (id && !canbeDelete.includes(status)) {
      // 除了0，1，3  其他状态不可以修改开始时间
      this.$data.ruleForm.dateRange[0] = this.$data.ruleForm.begin_at;
      this.$data.ruleForm.dateRange[1] = value[1];
    }
  }

  public onChangeRecommend(row: any) {
    const key = !row.is_recommend;
    this.$data.ruleForm.goods_group_list.forEach((item: any) => {
      item.is_recommend = 0;
    });
    row.is_recommend = key == false ? 0 : 1;
  }

  public onChangeLayout(e: any) {
    this.$data.ruleForm.styles.view_mode = e.target.attributes.dataKey.value;
  }

  // 选择关联商品
  public async relatedProduct(row: any, index: number) {
    this.$data.goodsInfo.goods = row.goods_list || [];
    this.$data.goodsInfo.goodsId = row.relative_goods;
    this.$data.goodsIndex = index;
    this.$data.goodsInfo.goodsShow = true;
  }

  // 保存商品
  public setGoods(goods: any) {
    const goodsId: any[] = [];
    goods.forEach((good: { sku_id: any }) => {
      goodsId.push(good.sku_id);
      return;
    });
    this.$data.ruleForm.goods_group_list[
      this.$data.goodsIndex
    ].goods_list = goods;
    this.$data.ruleForm.goods_group_list[
      this.$data.goodsIndex
    ].relative_goods = goodsId;
  }

  // 选择优惠券 https://cheaper-pack-testjdapp.zkyai.com/#/create/3/1/83/success
  public async navigateToPlugin(row: any, index: number) {
    this.$data.couponsInfo.couponsId = row.coupon_id || null;
    this.$data.couponsIndex = index;
    this.$data.couponsInfo.couponsShow = true;
  }

  // 保存优惠券
  public setCoupons(couponsId: string, name: string) {
    this.$data.ruleForm.settings.rules[
      this.$data.couponsIndex
    ].coupon_id = couponsId;
    this.$data.ruleForm.settings.rules[
      this.$data.couponsIndex
    ].coupon_name = name;
  }

  // 关闭商品优惠券弹窗
  public closeDialog() {
    this.$data.goodsInfo.goodsShow = false;
    this.$data.couponsInfo.couponsShow = false;
  }

  public addGoods() {
    this.$data.ruleForm.goods_group_list.push({
      relative_goods: [],
      ids: [],
      cover: "",
      name: "",
      is_recommend: 0,
    });
  }

  public addReduc() {
    this.$data.ruleForm.settings.rules.push({
      amount: undefined,
      ways: "1",
      content: "",
      coupon_name: "",
    });
  }

  public deleteReduc(i: number) {
    const form = "ruleForm";
    this.$data.ruleForm.settings.rules = this.$data.ruleForm.settings.rules.filter(
      (item: any, index: number) => {
        return index != i;
      }
    );
    // 移出校验规则
    (this.$refs[form] as any).clearValidate();
  }

  public deleteGoods(i: number) {
    const form = "ruleForm";
    this.$data.ruleForm.goods_group_list = this.$data.ruleForm.goods_group_list.filter(
      (item: any, index: number) => {
        return index != i;
      }
    );
    console.log(555, this.$data.ruleForm.goods_group_list);
    // 移出校验规则
    (this as any).$refs[form].clearValidate();
  }

  public async submitForm(formName: any) {
    const { ruleForm } = this.$data;
    if (
      this.$data.ruleForm.is_need_member == 1 &&
      !this.$data.member_join_url
    ) {
      (this as any).$message.error("请配置入会地址");
      return;
    }
    console.log("submitForm", this.$data.ruleForm);
    (this.$refs[formName] as any).validate(async (valid: any) => {
      if (valid) {
        const loading = (this as any).$loading({
          lock: true,
          text: "请稍等...",
          spinner: "el-icon-loading",
        });
        // 转换格式
        ruleForm.settings.status = ruleForm.settings.status ? 1 : 0;
        // 配置开始结束时间，删除多余参数
        ruleForm.begin_at = ruleForm.dateRange[0];
        ruleForm.end_at = ruleForm.dateRange[1];

        try {
          const act = await this.$store.dispatch("createAct", ruleForm);
          this.$router.push({
            path: `/create/3/1/${act.id}/success`,
          });
          loading.close();
        } catch (error) {
          loading.close();
          (this as any).$message.error(error.msg || error.message || error);
        }
      } else {
        console.log("error submit!!");
        return false;
      }
    });
  }
  public resetForm(formName: any) {
    // (this.$refs[formName] as any).resetFields();
    this.$router.push({ path: "/create/1" });
  }

  public openProductCoverDialog(row: any, index: number) {
    this.$data.isbgChoose = false;
    if (row == "bg") {
      this.$data.isbgChoose = true;
    }
    this.$data.productCoverDialogData.show = true;
    this.$data.productCoverDialogData.currentIndex = index;
    this.$data.productCoverDialogData.cover = this.$data.ruleForm.goods_group_list[
      index
    ].cover;
  }

  public onCoverhandleOk() {
    const { currentIndex } = this.$data.productCoverDialogData;
    let { cover = "" } = this.$data.productCoverDialogData;
    cover = cover.replace(/^(http(s?):)?(\/\/)?/, "https://");
    if (this.$data.isbgChoose) {
      this.$data.ruleForm.styles.background_image = cover;
      this.$data.productCoverDialogData.show = false;
      return;
    }
    // if(cover.indexOf('http:') == -1){
    //   cover = 'http:' + cover
    // }

    this.$data.ruleForm.goods_group_list[currentIndex].cover = cover;
    this.$data.productCoverDialogData.show = false;
  }

  public onCoverhandleCancel() {
    this.$data.productCoverDialogData.show = false;
  }
}
